import { useMutation } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { extractApiErrorMessage, type DownloadFileResult, toDownloadFileResult } from './download-utils'

export interface DownloadPrevidenciarioZipRequest {
  idPrevidenciario: string
  evento?: string
  labelDownload?: string
}

export function useDownloadPrevidenciarioZip() {
  const token = useAccessToken()
  const user = useCurrentUser()

  return useMutation({
    mutationFn: async ({
      idPrevidenciario,
      evento,
      labelDownload
    }: DownloadPrevidenciarioZipRequest): Promise<DownloadFileResult> => {
      if (!idPrevidenciario?.trim()) {
        throw new Error('idPrevidenciario é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      try {
        const response = await api.get<Blob>(`/previdenciario/downloads/zip/${idPrevidenciario.trim()}`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params:
            evento?.trim() || labelDownload?.trim()
              ? {
                  ...(evento?.trim() ? { evento } : {}),
                  ...(labelDownload?.trim() ? { label: labelDownload } : {})
                }
              : undefined,
          responseType: 'blob'
        })

        if (!response.data) {
          throw new Error('Erro ao baixar ZIP do previdenciário')
        }

        return toDownloadFileResult(response, `esocial-links-${idPrevidenciario.trim()}.zip`)
      } catch (error) {
        throw new Error(await extractApiErrorMessage(error, 'Erro ao baixar ZIP do previdenciário'))
      }
    }
  })
}
